var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAltTextinfoSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 465.168,
    height: 465.158,
    viewBox: "0 0 465.168 465.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage_Alt_Textinfo_Sad",
    "data-name": "Manage Alt Textinfo Sad",
    transform: "translate(-302.741 -2806.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 195.79,
    cy: 37.838,
    rx: 195.79,
    ry: 37.838,
    transform: "translate(306.241 3173.634)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search_2_",
    "data-name": "search (2)",
    transform: "translate(306.241 2810)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18009",
    "data-name": "Group 18009",
    transform: "translate(0 160.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12390",
    "data-name": "Path 12390",
    d: "M9.549,143.64a9.535,9.535,0,0,1-6.758-16.284L46.508,83.64a28.759,28.759,0,0,1,40.6,0l27.432,27.413,94.247-94.247a28.758,28.758,0,0,1,40.6,0l15.081,15.081a9.544,9.544,0,0,1-13.5,13.5L235.9,30.3a9.762,9.762,0,0,0-13.611,0L121.3,131.289a9.552,9.552,0,0,1-13.5,0L73.634,97.118a9.762,9.762,0,0,0-13.611,0L16.307,140.834a9.527,9.527,0,0,1-6.758,2.806Z",
    transform: "translate(0 -8.417)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18007",
    "data-name": "Group 18007",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12388",
    "data-name": "Path 12388",
    d: "M185.936,381.8H47.725A47.779,47.779,0,0,1,0,334.074V47.725A47.779,47.779,0,0,1,47.725,0H257.714a47.779,47.779,0,0,1,47.725,47.725V176.391a9.545,9.545,0,1,1-19.09,0V47.725A28.67,28.67,0,0,0,257.714,19.09H47.725A28.67,28.67,0,0,0,19.09,47.725V334.074a28.67,28.67,0,0,0,28.635,28.635H185.936a9.545,9.545,0,1,1,0,19.09Z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18008",
    "data-name": "Group 18008",
    transform: "translate(57.275 95.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12389",
    "data-name": "Path 12389",
    d: "M41.18,81.36A38.18,38.18,0,1,1,79.36,43.18,38.218,38.218,0,0,1,41.18,81.36Zm0-57.27A19.09,19.09,0,1,0,60.27,43.18,19.109,19.109,0,0,0,41.18,24.09Z",
    transform: "translate(-3 -5)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12391",
    "data-name": "Path 12391",
    d: "M256.979,242.251l-59.79-59.79a105.792,105.792,0,1,0-13.42,13.592l59.713,59.713a9.55,9.55,0,1,0,13.5-13.516ZM30.038,116.029a85.9,85.9,0,1,1,85.9,85.9,86.01,86.01,0,0,1-85.9-85.9Z",
    transform: "translate(198.397 199.604)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(253.401 282.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M197.249,251.239a4.74,4.74,0,0,1-6.695-.37,52.75,52.75,0,0,0-78.281,0,4.741,4.741,0,1,1-7.065-6.326,62.231,62.231,0,0,1,92.41,0A4.745,4.745,0,0,1,197.249,251.239Z",
    transform: "translate(-89.775 -167.103)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    d: "M231.708,156.449A23.734,23.734,0,0,1,208,132.741a4.741,4.741,0,0,1,9.483,0,14.224,14.224,0,1,0,28.449,0,4.741,4.741,0,1,1,9.482,0,23.734,23.734,0,0,1-23.706,23.708Z",
    transform: "translate(-132.137 -128)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822",
    "data-name": "Path 6822",
    d: "M117.931,132.742a4.741,4.741,0,1,1,9.483,0,23.707,23.707,0,1,1-47.414,0,4.742,4.742,0,1,1,9.483,0,14.224,14.224,0,1,0,28.449,0Z",
    transform: "translate(-80 -128)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18010",
    "data-name": "Group 18010",
    transform: "translate(349.434 3117.076)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 18.495,
    transform: "translate(74.494)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 29.447,
    transform: "translate(83.742)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 18.495,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 29.447,
    transform: "translate(9.247)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 14.796,
    y2: 29.447,
    transform: "translate(39.097)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 14.796,
    y2: 29.447,
    transform: "translate(39.097)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAltTextinfoSad);
export default __webpack_public_path__ + "static/media/manage-alt-textinfo-sad.478957ff116f68e892fff749e74d6ef6.svg";
export { ForwardRef as ReactComponent };